(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wod-campaign"] && !Shopify.designMode) return;
  try {
    
function initWodSlider(root){
 if(root.dataset.initialized)return;
 root.dataset.initialized='true';
 const slides=Array.from(root.querySelectorAll('[data-wod-slide]'));
 const choices=Array.from(root.querySelectorAll('[data-wod-select]'));
 const pause=root.querySelector('[data-wod-pause]');
 const status=root.querySelector('[data-wod-status]');
 const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
 let current=0,paused=root.dataset.autoplay!=='true'||reduced.matches,timer,hover=false,visible=false;
 function stop(){clearInterval(timer);timer=null;}
 function start(){stop();if(!paused&&!hover&&visible&&!document.hidden){timer=setInterval(()=>show((current+1)%slides.length,false),8000);}}
 function sync(){pause.textContent=paused?root.dataset.resumeLabel:root.dataset.pauseLabel;pause.setAttribute('aria-pressed',String(paused));start();}
 function show(index,user){if(user){paused=true;}current=index;slides.forEach((slide,i)=>{slide.hidden=i!==index;});choices.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));if(user){status.textContent=choices[index].textContent;root.scrollIntoView({block:'start',behavior:'instant'});}sync();}
 choices.forEach(button=>button.addEventListener('click',()=>show(Number(button.dataset.wodSelect),true)));
 pause.addEventListener('click',()=>{paused=!paused;sync();});
 root.querySelector('[data-wod-events]').addEventListener('click',()=>show(1,true));
 root.querySelector('[data-wod-agenda]').addEventListener('click',()=>{paused=true;root.querySelector('details').open=true;sync();});
 root.addEventListener('pointerenter',()=>{hover=true;stop();});
 root.addEventListener('pointerleave',()=>{hover=false;start();});
 root.addEventListener('focusin',()=>{paused=true;sync();});
 root.addEventListener('touchstart',()=>{paused=true;sync();},{passive:true});
 document.addEventListener('visibilitychange',start);
 reduced.addEventListener('change',()=>{if(reduced.matches){paused=true;sync();}});
 const observer=new IntersectionObserver(entries=>{visible=entries[0].intersectionRatio>0.6;start();},{threshold:[0,0.6]});
 function openCommunity(hash){
  const index=hash==='#wod-competencias'?1:hash==='#cuenta-con-wod'?2:-1;
  if(index<0)return;
  const drawer=document.querySelector('#Details-menu-drawer-container[open] > summary');
  if(drawer)drawer.click();
  document.querySelectorAll('header .header__inline-menu details[open]').forEach(details=>{details.open=false;details.querySelector('summary')?.setAttribute('aria-expanded','false');});
  show(index,true);
  if(index===1)root.querySelector('details').open=true;
 }
 function onHashChange(){openCommunity(window.location.hash);}
 function onCommunityClick(event){
  const link=event.target.closest('a[href]');
  if(!link||event.defaultPrevented||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
  const url=new URL(link.href,window.location.href);
  if(url.origin!==window.location.origin||url.pathname!==window.location.pathname)return;
  if(url.hash!=='#wod-competencias'&&url.hash!=='#cuenta-con-wod')return;
  event.preventDefault();
  if(window.location.hash!==url.hash)history.pushState(null,'',url.hash);
  openCommunity(url.hash);
 }
 window.addEventListener('hashchange',onHashChange);
 window.addEventListener('popstate',onHashChange);
 document.addEventListener('click',onCommunityClick);
 observer.observe(root);sync();onHashChange();
 root.addEventListener('wod:destroy',()=>{stop();observer.disconnect();document.removeEventListener('visibilitychange',start);window.removeEventListener('hashchange',onHashChange);window.removeEventListener('popstate',onHashChange);document.removeEventListener('click',onCommunityClick);},{once:true});
}
function loadWodSliders(scope){scope.querySelectorAll('[data-wod-slider]').forEach(initWodSlider);}
loadWodSliders(document);
document.addEventListener('shopify:section:load',event=>loadWodSliders(event.target));
document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-wod-slider]').forEach(root=>root.dispatchEvent(new Event('wod:destroy'))));

  } catch(e) { console.error(e); }
})();
})();
